export default {
  FeatureItem__OPENS_NEW_WINDOW: "Opens new window",
};
